export default {
  getters: {
    betaEnvName: () => process.env.VUE_APP_BETA_ENV_NAME,
    liveEnvName: () => process.env.VUE_APP_LIVE_ENV_NAME,
  },
}